/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import './SuperscriptBlock.scss';

export interface SuperscriptBlockProps {
  text: string;
  className?: string;
}

export const SuperscriptBlock = ({ text, className }: SuperscriptBlockProps) => {
  return (
    <div className={`superscript-wrap ${className ?? ''} ${text.includes('<sup>') ? ' superscript' : ''}`}>
      <span dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
};
